export type ServicesPaginationItem = number | 'ellipsis';

export const getServicesPaginationItems = (
  currentPage: number,
  totalPages: number
): ServicesPaginationItem[] => {
  if (totalPages <= 0) {
    return [];
  }

  if (totalPages <= 7) {
    return Array.from({length: totalPages}, (_value, index) => index + 1);
  }

  const safeCurrentPage = Math.min(Math.max(1, currentPage), totalPages);
  const visiblePages = new Set<number>([1, totalPages, safeCurrentPage]);

  if (safeCurrentPage <= 4) {
    [2, 3, 4, 5].forEach((page) => visiblePages.add(page));
  } else if (safeCurrentPage >= totalPages - 3) {
    [totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1].forEach((page) => {
      visiblePages.add(page);
    });
  } else {
    visiblePages.add(safeCurrentPage - 1);
    visiblePages.add(safeCurrentPage + 1);
  }

  const sortedPages = Array.from(visiblePages)
    .filter((page) => page >= 1 && page <= totalPages)
    .sort((left, right) => left - right);

  return sortedPages.reduce<ServicesPaginationItem[]>((items, page, index) => {
    const previousPage = sortedPages[index - 1];

    if (previousPage && page - previousPage > 1) {
      items.push('ellipsis');
    }

    items.push(page);
    return items;
  }, []);
};

export const formatServicesResultRange = (
  total: number,
  page: number,
  limit: number,
  visibleCount: number
) => {
  if (total <= 0 || visibleCount <= 0) {
    return 'Showing 0 results';
  }

  const start = Math.min(total, (Math.max(1, page) - 1) * limit + 1);
  const end = Math.min(total, start + visibleCount - 1);

  return `Showing ${start}-${end} of ${total} results`;
};
